<template>
	<div id="subjects" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">
						<span v-if="form.id > 0">Rol bewerken</span>
						<span v-else>Rol Aanmaken</span>
					</section>
				</header>
				<div class="card-content">
					<div class="content">
						<section>
							<form id="form">
								<b-field label="Naam" horizontal>
									<b-input v-model="form.name" style="width:300px;"></b-input>
								</b-field>

								<b-field horizontal>
									<b-field grouped>
										<b-field>
											<a class="button is-light" @click="$router.go(-1);">Terug</a>
										</b-field>
										<b-field>
											<a class="button is-primary" @click="submitForm(id)">Opslaan</a>
										</b-field>
									</b-field>
								</b-field>
							</form>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

 <script>
import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "subjects",
	props: ["id"],
	data() {
		return {
			school_id: localStorage.getItem("school_id"),
			schooltype_id: localStorage.getItem("schooltype_id"),
			user: Cookies.getJSON("user"),
			schools: [],
			classes: [],
			roles: [],
			levels: [],
			grades: [],
			subjecttypes: [],
			studies: [],
			loading_schools: false,
			loading_classes: false,
			form: {
				id: 0
			}
		};
	},
	created: function() {
		var self = this;

		if (this.id > 0) {
			this.getRole();
		}
	},
	watch: {
		"form.i_school_id": function(val) {
			console.log("school_id:" + val);

			this.getClasses(val);
			Cookies.set("selected_school", val);
		}
	},
	computed: {
		school() {
			return this.$store.getters.getSchool;
		},
		schooltype() {
			return this.$store.getters.getSchoolType;
		}
	},
	methods: {
		getRole() {
			var self = this;
			instance.get("/role/" + this.id).then(function(response) {
				self.form = response.data.data;
				console.log(self.form);
				console.log("Role ...");
			});
		},

		submitForm(formName) {
			var self = this;

			if (self.id > 0) {
				instance.post("/role-update", self.form).then(function(response) {
					console.log(self.user);
					console.log("Updates new schoolsector!!");

					self.$router.push({
						path: "/roles"
					});
				});
			} else {
				instance.post("/role", self.form).then(function(response) {
					self.$router.push({
						path: "/roles"
					});
				});
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
};
</script>
